import SegmentForm from "app/Dashboard/Integrations/SwitchTabs/SegmentForm"
import CustomSegmentRuleForm from "app/Dashboard/Integrations/SwitchTabs/CustomSegmentRuleForm"

const integrationTabs = {
    "Segments": SegmentForm,
    "Custom Segment Rules": CustomSegmentRuleForm,
}

export { integrationTabs }